/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $wrapNodeInElement } from '@lexical/utils';
import {
  $createParagraphNode,
  $insertNodes,
  $isRootOrShadowRoot,
  COMMAND_PRIORITY_EDITOR,
  createCommand,
  LexicalCommand
} from 'lexical';
import { useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { $createPollNode, createPollOption, PollNode } from '../../nodes/PollNode';

export const INSERT_POLL_COMMAND: LexicalCommand<string> = createCommand('INSERT_POLL_COMMAND');

export default function PollPlugin(): JSX.Element | null {
  const [editor] = useLexicalComposerContext();
  const userId = JSON.parse(localStorage.getItem('user'))?.id;

  useEffect(() => {
    if (!editor.hasNodes([PollNode])) {
      throw new Error('PollPlugin: PollNode not registered on editor');
    }

    return editor.registerCommand<string>(
      INSERT_POLL_COMMAND,
      (payload) => {
        const pollNode = $createPollNode(
          uuidv4(),
          payload,
          [createPollOption(''), createPollOption('')],
          new Date(),
          userId
        );
        $insertNodes([pollNode]);
        if ($isRootOrShadowRoot(pollNode.getParentOrThrow())) {
          $wrapNodeInElement(pollNode, $createParagraphNode).selectEnd();
        }

        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);
  return null;
}
